window.Util =
  shortReason: ->
    maxLength = 35;
    if this.reason.length > maxLength
      return "#{this.reason.substring(0, maxLength)}..."
    else
      return this.reason

